<app-header [compact]="true" />

<div class="content">
        <div class="content-title">Política de Privacidad de BarBook</div>
    
        <div class="element">
            <div class="element-title">1. Nombre de la Aplicación</div>
            <div class="element-content">BarBook</div>
        </div>
    
        <div class="element">
            <div class="element-title">2. Información de Contacto del Desarrollador</div>
            <div class="element-content">
                <div>Correo Electrónico: acanton@barbook.es</div>
                <div>Número de Teléfono: 644616607</div>
            </div>
        </div>
    
        <div class="element">
            <div class="element-title">3. Tipo de Información Recopilada</div>
            <div class="element-content">
                <div>BarBook recopila la siguiente información:</div>
                <ul>
                    <li>Correo electrónico (para el login)</li>
                    <li>Nombre de usuario</li>
                    <li>Datos de ubicación (GPS)</li>
                    <li>Bares que guarda el usuario</li>
                    <li>Listas de bares</li>
                    <li>Notas personales</li>
                    <li>Elementos compartidos</li>
                    <li>Búsquedas realizadas</li>
                    <li>Historial de interacciones</li>
                    <li>Notificaciones</li>
                    <li>Datos de perfil de redes sociales (Apple SSO, Google SSO)</li>
                </ul>
            </div>
        </div>
    
        <div class="element">
            <div class="element-title">4. Método de Recolección de Datos</div>
            <div class="element-content">
                <div>Los datos se recopilan a través de:</div>
                <ul>
                    <li>Formularios de registro e login</li>
                    <li>Buscador integrado</li>
                    <li>Servicios de geolocalización (GPS)</li>
                    <li>Autenticación SSO (Apple e Google)</li>
                    <li>Interacciones con la aplicación</li>
                </ul>
            </div>
        </div>
    
        <div class="element">
            <div class="element-title">5. Propósito de la Recopilación de Datos</div>
            <div class="element-content">
                <div>La información recopilada se utiliza para:</div>
                <ul>
                    <li>Ofrecer la funcionalidad principal de la aplicación: almacenar y organizar bares favoritos</li>
                    <li>Mostrar bares cercanos basado en la ubicación del usuario</li>
                    <li>Mejorar la experiencia de usuario y personalizar contenido</li>
                    <li>Fines estadísticos y analíticos</li>
                    <li>Mostrar anuncios relevantes a través de AdMob</li>
                </ul>
            </div>
        </div>
    
        <div class="element">
            <div class="element-title">6. Servicios de Terceros</div>
            <div class="element-content">
                <div>BarBook utiliza los siguientes servicios de terceros para proporcionar funcionalidades:</div>
                <ul>
                    <li><strong>Firebase</strong> - Base de datos y autenticación</li>
                    <li><strong>Google Places</strong> - Información y búsqueda de bares</li>
                    <li><strong>OpenStreetMap</strong> - Mapas y geolocalización</li>
                    <li><strong>AWS</strong> - Almacenamiento en nube</li>
                    <li><strong>Apple SSO</strong> - Autenticación con Apple</li>
                    <li><strong>Google SSO</strong> - Autenticación con Google</li>
                    <li><strong>AdMob</strong> - Servicio de publicidad</li>
                </ul>
                <div style="margin-top: 12px;">Estos servicios pueden procesar datos según sus propias políticas de privacidad. Te recomendamos revisar sus políticas para más información.</div>
            </div>
        </div>
    
        <div class="element">
            <div class="element-title">7. Datos de Ubicación (GPS)</div>
            <div class="element-content">
                <div>BarBook utiliza tus datos de ubicación para:</div>
                <ul>
                    <li>Mostrar tu posición en el mapa</li>
                    <li>Identificar bares cercanos a tu posición actual</li>
                    <li>Proporcionar sugerencias personalizadas basadas en la ubicación</li>
                </ul>
                <div style="margin-top: 12px;">Puedes controlar los permisos de ubicación en tu dispositivo. BarBook solo accede a tu ubicación cuando tienes la aplicación abierta y has concedido permiso.</div>
            </div>
        </div>
    
        <div class="element">
            <div class="element-title">8. Publicidad (AdMob)</div>
            <div class="element-content">
                <div>BarBook muestra anuncios a través de Google AdMob. Google puede utilizar datos de tu dispositivo para personalizar los anuncios. Puedes desactivar la publicidad personalizada en la configuración de tu dispositivo.</div>
            </div>
        </div>
    
        <div class="element">
            <div class="element-title">9. Cookies</div>
            <div class="element-content">
                <div>BarBook puede utilizar cookies y tecnologías similares para:</div>
                <ul>
                    <li>Fines estadísticos y analíticos</li>
                    <li>Mantener tu sesión iniciada</li>
                    <li>Mejorar la experiencia de usuario</li>
                </ul>
                <div style="margin-top: 12px;">Puedes controlar las cookies a través de la configuración de tu navegador web.</div>
            </div>
        </div>
    
        <div class="element">
            <div class="element-title">10. Compartir Información con Terceros</div>
            <div class="element-content">
                <div>No compartimos tus datos personales con terceros, excepto cuando es necesario para proporcionar los servicios mencionados en la sección "Servicios de Terceros".</div>
            </div>
        </div>
    
        <div class="element">
            <div class="element-title">11. Seguridad de la Información</div>
            <div class="element-content">
                <div>La información de los usuarios está securizada mediante encriptación y protocolos de seguridad estándar. Solo el usuario y los administradores autorizados pueden acceder a sus datos personales.</div>
            </div>
        </div>
    
        <div class="element">
            <div class="element-title">12. Derechos de los Usuarios</div>
            <div class="element-content">
                <div>Los usuarios tienen los siguientes derechos sobre sus datos:</div>
                <ul>
                    <li>Derecho de Acceso - Solicitar una copia de tus datos</li>
                    <li>Derecho de Rectificación - Corregir datos inexactos</li>
                    <li>Derecho de Eliminación - Solicitar la eliminación de tus datos y cuenta</li>
                    <li>Derecho de Portabilidad - Obtener tus datos en un formato legible</li>
                    <li>Derecho a la Oposición - Oponerme al procesamiento de tus datos</li>
                </ul>
                <div style="margin-top: 12px;">Para ejercer cualquiera de estos derechos, contacta a acanton@barbook.es con una descripción clara de tu solicitud.</div>
            </div>
        </div>
    
        <div class="element">
            <div class="element-title">13. Política de Retención de Datos</div>
            <div class="element-content">
                <div>Retenemos los datos de forma indefinida mientras tu cuenta esté activa. Cuando solicitas la eliminación de tu cuenta:</div>
                <ul>
                    <li>Los datos se marcan para eliminación inmediata</li>
                    <li>La eliminación completa de todos los datos puede tardar hasta 7 días desde la solicitud</li>
                    <li>Algunos datos pueden retenerse por razones legales o de seguridad</li>
                </ul>
            </div>
        </div>
    
        <div class="element">
            <div class="element-title">14. Enlaces a Otros Sitios Web</div>
            <div class="element-content">
                <div>Nuestra aplicación contiene enlaces a webs externas de bares y servicios como Google Maps. No somos responsables de las políticas de privacidad de estos sitios. Te recomendamos revisar sus políticas de privacidad.</div>
            </div>
        </div>
    
        <div class="element">
            <div class="element-title">15. Cambios en la Política de Privacidad</div>
            <div class="element-content">
                <div>Notificamos a los usuarios sobre cambios en la política de privacidad a través de:</div>
                <ul>
                    <li>Notificación push en la aplicación</li>
                    <li>Correo electrónico al correo usado en el login</li>
                    <li>Actualización en esta página</li>
                </ul>
                <div style="margin-top: 12px;">El uso continuado de la aplicación después de notificaciones de cambios implica tu aceptación de los cambios.</div>
            </div>
        </div>

        <div class="element">
            <div class="element-title">16. Ubicación de los Datos</div>
            <div class="element-content">
                <div>Los datos están almacenados y procesados en servidores ubicados en Europa:</div>
                <ul>
                    <li><strong>AWS</strong> - Servidores en regiones europeas</li>
                    <li><strong>Firebase</strong> - Servidores en ubicaciones europeas</li>
                </ul>
                <div style="margin-top: 12px;">Esto garantiza el cumplimiento con la normativa de protección de datos de la Unión Europea.</div>
            </div>
        </div>

        <div class="element">
            <div class="element-title">17. Transferencia de Datos Internacionales</div>
            <div class="element-content">
                <div>Los datos se almacenan principalmente en Europa. Sin embargo, algunos servicios de terceros como Google SSO pueden procesar datos en múltiples jurisdicciones según sus políticas de privacidad.</div>
            </div>
        </div>

        <div class="element">
            <div class="element-title">18. Contacto para Privacidad</div>
            <div class="element-content">
                <div>Si tienes preguntas sobre esta política de privacidad o deseas ejercer cualquiera de tus derechos, contacta a:</div>
                <ul>
                    <li>Correo: acanton@barbook.es</li>
                    <li>Teléfono: 644616607</li>
                </ul>
                <div style="margin-top: 12px;">Responderemos a tus consultas en un plazo de 30 días.</div>
            </div>
        </div>
    </div>